import type { SocialCaptions } from 'bundles/sharing-common/types/sharingSharedTypes';

import _t from 'i18n!nls/promotions';

type GetSocialCaptionsArgs = {
  expirationDate: string;
};

export default ({ expirationDate }: GetSocialCaptionsArgs): SocialCaptions => {
  return {
    twitter: () => _t('Check out this limited-time promotion from @Coursera and start learning today!'),
    whatsapp: (shareLink) =>
      _t(
        'Start learning today! Coursera is offering a limited-time promotion until #{expirationDate} on these courses. ' +
          '#{shareLink} Check out Coursera! With Coursera, you can take online courses created by leading universities and companies like Yale, Google, the University of Michigan, and much more.',
        {
          shareLink,
          expirationDate,
        }
      ),
    emailSubject: () => _t('Check out this offer from Coursera!'),
    emailBody: (shareLink) =>
      _t(
        'Start learning today with Coursera’s limited-time promotion until #{expirationDate} #{shareLink}\n\nHappy Learning!\n\n' +
          'With Coursera, you can take online courses created by leading universities and companies like Yale, Google, the University of Michigan, and much more.',
        {
          shareLink,
          expirationDate,
        }
      ),
  };
};
